import { CheckOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

import React, { useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'next-i18next';
import styled, { keyframes } from 'styled-components';

type IconType = typeof EyeInvisibleOutlined;
type IconMapType = keyof typeof iconMap;

const iconMap = {
  eyeInvisible: EyeInvisibleOutlined,
  check: CheckOutlined,
};

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const expandWidth = keyframes`
  33% {
    width: 40px;
  }
  100% {
    width: calc(40px + 130px);
  }
`;

const Circle = (is_private: boolean) => styled.div`
  width: auto;
  min-width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: ${!is_private ? '#d2ecd8' : '#f9dad9'};
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  animation: ${fadeIn} 0.5s ease-in-out forwards;
  position: relative;
`;

const createStyledIcon = (type: IconType) => styled(type).attrs({
  style: { opacity: 1 },
})`
  width: 20px;
  height: 20px;
  animation: ${fadeIn} 0.5s ease-in-out forwards;
`;

const Icon = ({ type }: { type: IconMapType }) => {
  const IconComponent = iconMap[type];
  const StyledIcon = createStyledIcon(IconComponent);
  return <StyledIcon />;
};

const Label = styled.span`
  white-space: nowrap;
  font-size: 14px;
  margin-left: 5px;
  opacity: 0;
  animation: ${fadeIn} 0.5s ease-in-out forwards 1s;
`;

const WrapperFn = (is_private: boolean) => styled.div`
  color: ${!is_private ? '#38c13d' : '#FF6464'};
  display: inline-block;
  overflow: hidden;
  width: 40px;
  animation: ${expandWidth} 1.5s ease-in-out forwards 0s;
`;

const TrackingComponent = ({ is_private }: { is_private?: boolean }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation('common');

  const Circles = Circle(is_private);
  const Wrapper = WrapperFn(is_private);

  useEffect(() => {
    // const timeoutId = setTimeout(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.width = 'auto';
    }
    // }, 0);

    // return () => {
    //   clearTimeout(timeoutId);
    // };
  }, []);

  const getContent = useMemo(
    () => (
      <Wrapper ref={wrapperRef}>
        <Circles>
          <Icon type={!is_private ? 'check' : 'eyeInvisible'} />
          <Label>{t(!is_private ? 'Trackable' : 'Private')}</Label>
        </Circles>
      </Wrapper>
    ),
    [wrapperRef, is_private]
  );

  return getContent;
};

export default TrackingComponent;
